import { useEffect, useRef, useState } from "react";

let cache;
export const loadNpa = () => (cache ||= import("./npa_ch.json").then((m) => m.default));

export const NPA_RE = /^[1-9]\d{3}$/;

// Returns {info, warning} for a Swiss NPA; calls onCity(firstLocality) when a new valid NPA is typed.
export const useNpa = (npa, onCity) => {
  const [list, setList] = useState(null);
  useEffect(() => { loadNpa().then(setList).catch(() => setList({})); }, []);
  const v = (npa || "").trim();
  const info = list && NPA_RE.test(v) ? list[v] || null : null;
  const first = useRef(v);
  useEffect(() => {
    if (info && onCity && v !== first.current) onCity(info.l[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [info]);
  let warning = "";
  if (list && NPA_RE.test(v)) {
    if (!info) warning = "NPA introuvable dans la liste suisse : vérifiez-le (la demande peut quand même être envoyée).";
    else if (info.c !== "VD") warning = "Hors de notre zone habituelle, nous vous répondrons quand même.";
  }
  return { info, warning, cities: info ? info.l : [] };
};

export const addressErrors = (a, prefix = "") => {
  const e = {};
  if ((a.street || "").trim().length < 3 || !/[A-Za-zÀ-ÿ]{2}/.test(a.street || "")) e[`${prefix}street`] = "Veuillez indiquer la rue et le numéro.";
  if (!NPA_RE.test((a.npa || "").trim())) e[`${prefix}npa`] = "NPA invalide : 4 chiffres (ex. 1003).";
  if ((a.city || "").trim().length < 2) e[`${prefix}city`] = "Veuillez indiquer la localité.";
  return e;
};
